import logo from '../../assets/helthyLogo.png'

export const Logo = (): JSX.Element => {
  return <img src={logo} width="200" height="auto" alt="" id="LogoHelthy" />
}
